import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4827478d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "title text-input input-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titolo del documento", -1))
const _hoisted_4 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "requires-signature" }, "Richiede la firma (solo file PDF)", -1))
const _hoisted_6 = {
  key: 0,
  class: "block font-light text-red-500"
}
const _hoisted_7 = { class: "input-content text-input" }
const _hoisted_8 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_9 = {
  key: 0,
  class: "title-row grid grid-cols-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tags-title-col" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Scegli i tag")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "tags-row"
}
const _hoisted_13 = {
  key: 1,
  class: "content overflow-hidden"
}
const _hoisted_14 = { class: "global-event-section items-end" }
const _hoisted_15 = { class: "is-global text-input pb-4 py-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is-special" }, "Documento Globale", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global-event-description pb-4 pl-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Se settato come \"Globale\", questo documento sarà visualizzabile da tutti gli utenti."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("In caso contrario sarà visualizzabile solamente agli utenti selezionati")
  ])
], -1))
const _hoisted_18 = { class: "left-content" }
const _hoisted_19 = { class: "searchbar flex" }
const _hoisted_20 = { class: "user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_21 = { class: "working-site-title font-bold" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "right-content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-description-voices grid grid-cols-2 gap-4 py-3 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "pl-3" }, "Dipendente"),
  /*#__PURE__*/_createElementVNode("div", { class: "delete" })
], -1))
const _hoisted_25 = { class: "added-user-list overflow-y-scroll custom-scrollbar" }
const _hoisted_26 = { class: "working-site-title font-bold" }
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_UploadForm = _resolveComponent("UploadForm")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, null, {
    h1: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.titleText), 1)
    ]),
    h2: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.subtitleText), 1)
    ]),
    h3: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.steps), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_PrimaryButton, {
        class: "button bg-white text-primary-900 undo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.step == 0 ? 'Annulla' : 'Indietro'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_PrimaryButton, {
        class: "button bg-primary-900 text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onConfirm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.step == 0 && _ctx.scope == _ctx.DocumentScope.workingSiteDocument ? 'Avanti' : _ctx.actionText), 1)
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            message: "Salvataggio..."
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.step == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["bg-primary-50 border-red-400", { border: _ctx.v$.step1.title.$error }]),
                id: "title",
                type: "text",
                placeholder: "Inserisci il titolo del documento",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.title) = $event)),
                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.title.$touch && _ctx.v$.step1.title.$touch(...args)))
              }, null, 34), [
                [_vModelText, _ctx.step1.title]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.title.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_4, "È necessario inserire il titlo del documento"))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            (_ctx.scope == _ctx.DocumentScope.userDocument)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["input-content requires-signature text-input pb-6 py-3", { disabled: _ctx.fileIsNotPDF }])
                }, [
                  _createVNode(_component_Toggle, {
                    class: "inline-block self-center",
                    id: "requires-signature",
                    modelValue: _ctx.step1.requiresSignature,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.requiresSignature) = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_5,
                  (_ctx.fileIsNotPDF)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È possibile richiedere la firma solo di documenti di tipo PDF"))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_UploadForm, {
                modelValue: _ctx.step1.file,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.file) = $event)),
                  _ctx.v$.step1.file.$touch
                ],
                error: _ctx.v$.step1.file.$error
              }, null, 8, ["modelValue", "onUpdate:modelValue", "error"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.file.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_8, "È necessario caricare un allegato"))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.tagIds != undefined && _ctx.tagsAllowed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true),
              (_ctx.tagIds != undefined && _ctx.tagsAllowed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                      return (_openBlock(), _createBlock(_component_PrimaryButton, {
                        class: _normalizeClass(["button", { 'bg-primary-900': _ctx.isAdded(tag), 'text-white': _ctx.isAdded(tag), 'bg-primary-100': !_ctx.isAdded(tag), 'text-primary-900': !_ctx.isAdded(tag) }]),
                        onClick: ($event: any) => (_ctx.toggleTag(tag))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isAdded(tag) ? '-' : '+') + " " + _toDisplayString(tag.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 256))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Toggle, {
                  class: "inline-block self-center",
                  id: "is-special",
                  modelValue: _ctx.step2.isGlobal,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step2.isGlobal) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_16
              ]),
              _hoisted_17
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["grid grid-cols-2 gap-4", { disabled: _ctx.step2.isGlobal }])
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["text px-4 py-3 flex-grow user-filter-input", { disabled: _ctx.step2.isGlobal }]),
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usersSearchFilter) = $event)),
                    type: "text",
                    placeholder: "Inserisci il nome del dipendente"
                  }, null, 2), [
                    [_vModelText, _ctx.usersSearchFilter]
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button text-primary flex-none font-bold find", { disabled: _ctx.step2.isGlobal }]),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchUsers()))
                  }, "Cerca", 2)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unselectedUsers, (unselectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user",
                      key: unselectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(unselectedUser.name) + " " + _toDisplayString(unselectedUser.surname), 1),
                      _createElementVNode("button", {
                        class: "add-working-site font-bold",
                        onClick: ($event: any) => (_ctx.addUser(unselectedUser))
                      }, "Aggiungi", 8, _hoisted_22)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (selectedUser) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "user grid grid-cols-2",
                      key: selectedUser.id
                    }, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(selectedUser.name) + " " + _toDisplayString(selectedUser.surname), 1),
                      _createElementVNode("button", {
                        class: "remove-user font-bold",
                        onClick: ($event: any) => (_ctx.removeUser(selectedUser.id))
                      }, "Elimina", 8, _hoisted_27)
                    ]))
                  }), 128))
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}